import './required-questions.scss';
import React from 'react';
import Question from './Question';
var RequiredQuestions = function RequiredQuestions(_ref) {
  var RequiredQuestionsWrapper = _ref.requiredQuestionsWrapper,
    requiredQuestions = _ref.requiredQuestions,
    answers = _ref.answers,
    questionsRequiringPreviousSelection = _ref.questionsRequiringPreviousSelection,
    methods = _ref.methods;
  if (requiredQuestions.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RequiredQuestionsWrapper, null, requiredQuestions.map(function (question) {
    return /*#__PURE__*/React.createElement(Question, {
      answers: answers,
      key: question.label,
      name: "answers[".concat(question.label, "]"),
      question: question,
      required: true,
      questionsRequiringPreviousSelection: questionsRequiringPreviousSelection,
      methods: methods
    });
  }));
};
export default RequiredQuestions;